export default {
  language: "언어",
  login: "로그인",
  logout: "로그아웃",
  mypage: '마이페이지',
  privatelegal: "개인 정보처리 동의방침",
  email: "이메일",
  password: "비밀번호",
  username: "이름",
  noise: '노이즈',
  reduction: '제거',
  nr: "노이즈 제거",
  recording: "웹녹음",
  encoding: "인코딩",
  edit: "음성편집",
  editing: "편집",
  pricing: "프리미엄",
  web: "웹",
  audio: "오디오",
  advertise: "광고",
  nrb1: "사용법",
  nrb2: "뛰어난 잡음 제거",
  nrb3: "간편한 사용",
  nrb4: "안전한 프라이버시 보호",
  nrb5: "가벼운 로컬 리소스",
  nrb6: "Web과 App",
  recb1: "사용법",
  recb2: "실시간 녹음 현황",
  recb3: "간편한 사용",
  recb4: "안전한 프라이버시 보호",
  recb5: "다양한 코덱 지원",
  recb6: "Web과 App",
  editb1: "사용법",
  editb2: "마우스 사용",
  editb3: "간편한 사용",
  editb4: "안전한 편집 작업",
  editb5: "필요한 기능만",
  editb6: "Web과 App",
  logout_confirm: "로그아웃 하시겠습니까 ?",
  phrase: {
    easyRecording: "별도의 프로그램 설치 없이 웹에서 간편하게 녹음하세요.",
    startRecording: "아래의 빨강 버튼을 클릭하고 녹음을 시작하세요.",
    record1: "버튼을 눌러서 녹음을 시작하세요.",
    record2: "녹음된 음성을 들어보세요.",
    record3: "파일을 저장하기 위해 다운로드를 클릭하세요.",
    deeplearning: "딥러닝 기술을 이용해서 음성으로부터 소음을 제거합니다",
    easyEncoding: "웹에서 간편하게 인코딩 하세요. ",
    startEncoding: "파일을 업로드 하고 원하는 형태로 인코딩을 진행하세요..",
    encode1: "인코딩이 필요한 음성 파일을 추가하세요.",
    encode2: "선택한 옵션을 적용하여 인코딩합니다.",
    encode3: "파일을 저장하기 위해 다운로드를 클릭하세요.",
    upload: '잡음을 제거하고자 하는 음성 파일을 추가하세요.',
    Processing: '딥러닝 인공지능으로 깨끗한 음성을 복원합니다.',
    Download: '파일을 저장하기 위해 다운로드를 클릭하세요.',
    editTitle: "별도의 프로그램 설치 없이 웹에서 간편하게 편집하세요.",
    editDirection1: "입력파일을 선택",
    editDirection2: "하거나 그림창에 drag&drop을 하세요.",
    editWheel: "마우스로 선택하고 아래 버튼을 이용하세요(마우스 휠 사용가능).",
    nrb1_sub: "오디오 파일을 상자로 드래그 앤 드롭하거나 상자를 클릭하여 탐색기를\
    통해 파일을 선택하세요. 업로드된 파일을 확인 후 잡음제거 버튼을\
    클릭하면 자동으로 잡음이 제거됩니다. 완료된 파일을 미리 들어보고\
    다운로드가 가능합니다.",
    nrb2_sub: "Voice Noise Reduction은 딥러닝 인공지능을 이용한 잡음제거 서비스를 제공합니다.\
    오디오 관련 프로그램을 설치하고 온라인에서 접할 수 있는 튜토리얼을 따라 잡음을 제거하는 기존의 방식보다\
    높은 잡음 제거 성능이 제공되며 결과물의 품질도 뛰어납니다.",
    nrb3_sub: "몇 번의 클릭으로 쉽고 간편하게 오디오 파일의 잡음을 제거합니다.\
    오디오 프로그램을 설치하는 기존의 방식과 달리 별도의 프로그램을 설치할 필요가 없으며 네트워크 환경에\
    문제가 없다면 수십초 이내에 결과물을 확인할 수 있습니다.",
    nrb4_sub: "업로드한 원본 파일은 노이즈 제거 작업 완료 후 즉시 삭제됩니다.\
    결과파일 또한 1시간 후 서버에서 영구히 삭제됩니다.  누구도 사용자의 파일에 접근권한을 갖고 있지 않으며,\
    사용자의 개인 정보는 안전하게 보호됩니다.",
    nrb5_sub: "Voice Noise Reduction은 인터넷 연결을 통해 어디에서나 서비스를 사용할 수 있습니다.\
    딥러닝을 통한 프로세싱은 모두 클라우드에서 진행됩니다.\
    그러므로 사용자 컴퓨터의 리소스를 소모하지 않습니다.",
    nrb6_sub: "Voice Noise Reduction은 WEB을 통해 간편하게 사용하실 수 있으며 모바일 어플리케이션으로도 사용할 수 있습니다.\
    모바일 어플리케이션은 음성 녹음과 노이즈 제거에 중점을 두고 있으며 사용하기 편리하며 성능이 좋은 녹음기의 역할을 수행합니다.",

    recb1_sub: "녹음 버튼을 클릭하고 녹음을 시작하세요. 마이크 장치가 컴퓨터와 연결되어\
    있어야 합니다. 또한 브라우저의 마이크 장치 접근을 허용해야 합니다. 녹음을 시작하기 전에\
    코덱을 설정하세요.",
    recb2_sub: "실시간으로 변화하는 파형을 통해 녹음이 원활하게 진행되고 있는지 확인하세요.",
    recb3_sub: "몇 번의 클릭으로 쉽고 간편하게 녹음하세요. 녹음 프로그램을 설치하는\
    기존의 방식과 달리 별도의 프로그램을 설치할 필요가 없습니다.",
    recb4_sub: "녹음은 사용자의 컴퓨터에서만 이루어집니다.\
    클라우드에 업로드되지 않으므로 어떠한 외부 사용자도 사용자의 녹음 파일에 접근할 수 없으며 사용자의 개인 정보는 안전하게 보호됩니다.",
    recb5_sub: "다양한 포맷, 샘플레이트, 비트레이트와 채널을 설정하여 녹음할 수 있습니다.\
    세부적인 설정을 하지 않는다면 음성과 파일 저장용량에 최적의 상태로 설정되어 녹음됩니다.",
    recb6_sub: "Audio Noise Reduction은 WEB을 통해 간편하게 사용하실 수 있으며\
    모바일 어플리케이션으로도 사용할 수 있습니다. 모바일 어플리케이션은\
    음성 녹음과 노이즈 제거에 중점을 두고 있으며 사용하기 편리하며 성능이\
    좋은 녹음기의 역할을 수행합니다.",

    editb1_sub: "오디오 파일을 상자로 드래그 앤 드롭하거나 파일을 선택하여 편집을 시작하세요\
    마우스를 클릭하고 드래그하여 구간을 선택한 수 다양한 작업을 시행할 수 있습니다.",
    editb2_sub: "파형 화면에서 마우스 휠을 사용해서 파형의 확대 및 축소를 할 수 있습니다.\
    시간축의 라벨 영역을 마우스로 끌어서 파형의 시간을 이동하세요.  y축의 라벨영역에서 휠을 사용하면 y축 레벨을 조절할 수 있습니다.",
    editb3_sub: "프로그램 다운로드와 설치는 필요하지 않습니다.\
    웹에서 바로 파일을 선택하고 직관적이고 간단한 버튼을 통해서 오디오를 편집하세요",
    editb4_sub: "편집할 파일은 사용자의 컴퓨터에서만 이루어집니다.\
    클라우드에 업로드되지 않으므로 어떠한 외부 사용자도 사용자의 녹음 파일에 접근할 수 없으며 로그인 없이 자유롭게 사용이 가능합니다.",
    editb5_sub: "복잡한 기존의 오디오 편집기와 다르게 웹 오디오 편집 서비스는 필수적인 기능위주로 구현되어 있습니다.",
    editb6_sub: "Audio Noise Reduction은 WEB을 통해 간편하게 사용하실 수 있으며\
    모바일 어플리케이션으로도 사용할 수 있습니다. 모바일 어플리케이션은\
    음성 녹음과 노이즈 제거에 중점을 두고 있으며 사용하기 편리하며 성능이\
    좋은 녹음기의 역할을 수행합니다.",
  }

};
